import { Component, Input, OnInit } from '@angular/core';
import { IconService } from 'src/app/shared/services/icon.service';

@Component({
  selector: 'app-exams-and-tasks-list-view-block-list',
  templateUrl: './exams-and-tasks-list-view-block-list.component.html',
  styleUrls: ['./exams-and-tasks-list-view-block-list.component.scss'],
})
export class StudentExamsAndTasksListViewBlockListComponent {
    @Input() pageData: any;
}
